import { defineStore } from 'pinia'

type TStoreType = {
    queue: [],
    active: any
};

// registers the first user interaction with the DOM (to unmute videos)
export const useVideoStore = defineStore('video', {
  state: (): TStoreType => {
    return {
      queue: [],
      active: undefined
    }
  },
  actions: {
    addVideoToQueue (el) {
      const index = this.$state.queue.indexOf(el)
      if (index === -1) {
        this.$state.queue.unshift(el)
        this.$state.active = el
      }
    },
    removeVideoFromQueue (el) {
      const index = this.$state.queue.indexOf(el)

      if (index !== -1) {
        const duplicateState = [...this.$state.queue]
        duplicateState.splice(index, 1)
        this.$state.queue = duplicateState

        if (this.$state.active === el) {
          this.$state.active = duplicateState[0]
        }
      }
    }
  },
  getters: {
    getActive: state => state.active
  }
})
